import React, { Component, Fragment } from 'react';
import {withRouter} from 'react-router-dom';
import Loading from '../../../hoc/Loading/Loading';
import * as actionCreators from '../../../modules/actions/index';
import { connect } from 'react-redux';
import * as url from '../../../utils/url';
import { Container, Row, Col, Table } from 'reactstrap';
import moment from 'moment';
import axios from '../../../axios';
import {checkUserPrivileges,privacyLabel} from '../../../utils/constants';
import NoKpiPlaceholder from '../../../assets/placeholders/no_kpi_available.svg';

class ChartDashboards extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      // tools:this.props.tools,
      // linkedTools:this.props.linkedTools
      dashboard_array:[]
     }
  }

  
  componentDidMount(){
    // this.getAttachedItems(this.props)
    // export const getChartDashboards = '/charts/v1/chart-dashboard-list'isChartView, chart
    let results = {
      isChartView:true,
      chart:this.props.chart
    }

    let that = this

    console.log('dashboard ---- list')

  axios.post(url.getChartDashboards, results)
  .then(response => {
    let results = response.data.data
    console.log('dashboard: ', results)
    that.setState({dashboard_array:[...results]})
  })
  .catch(error => {
    console.log("err--",error)
  })

}

  
  viewDashboard=dashboard=>{
    let dashboard_link = `/home/dashboard/${this.props.user.profile.organizationId._id}/view/${dashboard._id}`
    this.props.history.push(dashboard_link);
  }

  navDashboardList=()=>{
    let url =  `/home/dashboard-list/${this.props.user.profile.organizationId._id}` 
    this.props.history.push(url);
  }


  closeModal=()=>{
    this.props.closeViewChartModal()
  }
 
  renderView=()=>{
    let{dashboard_array}=this.state
    if(dashboard_array&&dashboard_array.length>0){
      return (
        <div className="singleTaskToolkitTableContainerBox">
        <Table responsive hover className="taskToolkitTable">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Dashboard Owner</th>
                    <th>Charts Linked</th>
                    <th>Permissions</th>
                  </tr>
                </thead>
                <tbody>
              
                  { dashboard_array.map((e,idx) => {
                    let dashboard=e
                      return <React.Fragment key={idx+dashboard._id}>
                         <tr className="linkedToolTable" key={dashboard._id} >
                                <td >
                                  {dashboard.name}  
                                </td>
                                                    
                                <td >
                                  {dashboard.createdBy.firstName} {dashboard.createdBy.lastName}                     
                                </td>
                      
                                <td >
                                 {dashboard.chartCount}                    
                                </td>
                      
                                <td >
                                   {/* {moment(dashboard.createdDate).format('MMM Do, YYYY')} */}
                                   {checkUserPrivileges(this.props.user.profile, dashboard)!=false?
                                   <span className="linkedToolView" onClick={()=>this.viewDashboard(dashboard)}> {privacyLabel[dashboard.privacy]} (view)</span>:
                                   <span>private</span>
                                   }
                                </td>
                              </tr>
                         </React.Fragment>
                  })}
                
                </tbody>
              </Table>
              </div>
      
           
      )
   
    } else {
      return (
        <div className='cl_no_db_linked_chart_container'>
          <div className='cl_no_db_linked_chart_txt'> 
          <span><strong>No dashboards linked. </strong> </span>
          <span>To create a dashboard, select the 
            <strong> "Dashboard"</strong> tab from the left-hand menu (or click  
            <span className="dashboardListSingleLink"onClick={()=>this.navDashboardList()}> here</span>). </span>
              
              <span>To add this chart to a dashboard, close this pop-up ("X" at the top right or 
              click <span className="dashboardListSingleLink"onClick={()=>this.closeModal()}> here</span>) 
              and select the 
              <strong> "Add to dashboard"</strong> option from the hamburger menu &nbsp;<i className="chart-item-menu flaticon-menu-1" />&nbsp; 
              of the respective chart.</span>
          </div>
          <img className='cl_no_db_linked_chart_img' src={NoKpiPlaceholder} />          
        </div>
        
      )
    }
  }


  render() { 
    return  this.renderView()
  }
}

const mapStateToProps = state => {
  return {
    user: state.user,
    kpiMaster: state.kpiMaster,
    mappingMaster: state.mappingMaster
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onKpiMasterListFetched: (data) => dispatch(actionCreators.storeKpiMaster(data)),
    onMappingMasterListFetched: (data) => dispatch(actionCreators.storeMappingMaster(data)),
    onProfileUpdate: (data) => dispatch(actionCreators.updateProfileInfoSuccess(data)),
    updateNavBar: (header) => dispatch(actionCreators.navBarUpdate(header))
  }
}
 
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Loading(ChartDashboards, axios)));
